import { render, staticRenderFns } from "./Restore.vue?vue&type=template&id=282d2669&scoped=true&lang=pug&"
import script from "./Restore.vue?vue&type=script&lang=js&"
export * from "./Restore.vue?vue&type=script&lang=js&"
import style0 from "./Restore.vue?vue&type=style&index=0&id=282d2669&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d2669",
  null
  
)

export default component.exports